document.querySelectorAll('.rca-add-to-cart-submit').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
  
  
      setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          fetch('/cart?sections=cart-drawer,cart-icon-bubble')
            .then((response) => response.json())
            .then((sections) => {
              const cartDrawerContent = sections['cart-drawer'];
              const cartBubbleContentHTML = sections['cart-icon-bubble'];
  
              if (cartDrawerContent) {
                if (cartDrawerContent.includes('cart-item')) {
                  cartDrawer.classList.remove('is-empty');
                }
  
                cartDrawer.renderContents({
                  sections: {
                    'cart-drawer': cartDrawerContent,
                  }
                });
              } else {
                console.error('Cart drawer content not found in the response');
              }
  
              const parser = new DOMParser();
              const doc = parser.parseFromString(cartBubbleContentHTML, 'text/html');
              const newCartBubble = doc.querySelector('.cart-count-bubble');
              const existingCartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  
              if (newCartBubble) {
                if (existingCartBubble) {
                  existingCartBubble.innerHTML = newCartBubble.innerHTML;
                } else {
                  const cartIcon = document.querySelector('#cart-icon-bubble');
                  cartIcon.insertAdjacentHTML('beforeend', newCartBubble.outerHTML);
                }
              }
            })
            .catch((error) => console.error('Error updating cart drawer:', error));
        }
  
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }, 1000);
    });
  });
  